<div id="app-wrapper">
  <router-outlet></router-outlet>
</div>
